// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"styles_checkbox__3d72q","input":"styles_input__3qQVm","checkmark":"styles_checkmark__2Q_ju","text":"styles_text__3ymtj","error":"styles_error__LFMzC"};